
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/goal/[goalSlug]/[goalUID]/subscribe",
      function () {
        return require("private-next-pages/goal/[goalSlug]/[goalUID]/subscribe.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/goal/[goalSlug]/[goalUID]/subscribe"])
      });
    }
  